export const convertMinutesToHours = (
  minutes: number,
  suffix = {
    hours: "hours",
    minutes: "mins",
  },
) => {
  if (minutes < 0) throw new Error("Invalid Minute should be greater than 0");
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}${suffix.hours} ${remainingMinutes}${suffix.minutes}`;
};

export const convertTimeTo12HourFormat = (time: string) => {
  if (!time?.includes(":")) {
    throw new Error(
      "Invalid Input: Time string must include a colon (:) character",
    );
  } else {
    const [hours, minutes] = time.split(":");
    const hourTypeError = Number.isNaN(Number(hours));
    const minuteTypeError = Number.isNaN(Number(minutes));
    if (hourTypeError && minuteTypeError)
      throw new Error("Invalid Input for Hour and Minute");

    if (hourTypeError) throw new Error("Invalid Input Hour should be a number");

    if (minuteTypeError)
      throw new Error("Invalid Input Minute should be a number");

    if ((+hours < 0 || +hours > 23) && (+minutes < 0 || +minutes > 59))
      throw new Error("Invalid Time Input");

    if (+hours < 0 || +hours > 23)
      throw new Error("Invalid Input Hour should be between 0 and 23");

    if (+minutes < 0 || +minutes > 59)
      throw new Error("Invalid Input Minute should be between 0 and 59");

    const isAM = Number(hours) < 12;
    const convertedHours = Number(hours) % 12 || 12;
    return `${convertedHours}:${minutes} ${isAM ? "AM" : "PM"}`;
  }
};

export function format24HourTime(timeString: string) {
  if (!timeString.includes(":")) {
    throw new Error(
      "Invalid Input: Time string must include a colon (:) character",
    );
  } else {
    const [hourString, minute] = timeString.split(":");
    const hourStringTypeError = Number.isNaN(Number(hourString));
    const minuteStringTypeError = Number.isNaN(Number(minute));

    if (hourStringTypeError && minuteStringTypeError)
      throw new Error("Invalid Input for Hour and Minute");

    if (hourStringTypeError)
      throw new Error("Invalid Input Hour should be a number");

    if (minuteStringTypeError)
      throw new Error("Invalid Input Minute should be a number");

    if ((+hourString < 0 || +hourString > 23) && (+minute < 0 || +minute > 59))
      throw new Error("Invalid Time Input");

    if (+hourString < 0 || +hourString > 23)
      throw new Error("Invalid Input Hour should be between 0 and 23 ");

    if (+minute < 0 || +minute > 59)
      throw new Error("Invalid Input Minute should be between 0 and 59 ");

    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? " AM" : " PM");
  }
}

export function convertDateToDateString(value: Date) {
  return value.toISOString().split("T")[0];
}
